/**
 * Canonical platform pricing — single source of truth for booking fee math and labels.
 * Renter: platform fee added to rental subtotal. Sharer: platform fee deducted from subtotal.
 */

/** Added to renter booking total (on rental subtotal). */
export const RENTER_PLATFORM_FEE_PERCENTAGE = 0.1 as const;

/** Deducted from sharer rental earnings (on rental subtotal). */
export const SHARER_PLATFORM_FEE_PERCENTAGE = 0.15 as const;

/** Sharer net as a fraction of rental subtotal (before disputes, deposits, etc.). */
export const SHARER_NET_OF_RENTAL_SUBTOTAL_MULTIPLIER =
  1 - SHARER_PLATFORM_FEE_PERCENTAGE;

export const PRICING_CONSTANTS = {
  RENTER_PLATFORM_FEE_PERCENTAGE,
  SHARER_PLATFORM_FEE_PERCENTAGE,

  /** @deprecated Use RENTER_PLATFORM_FEE_PERCENTAGE */
  SERVICE_FEE_PERCENTAGE: RENTER_PLATFORM_FEE_PERCENTAGE,
  /** @deprecated Use SHARER_PLATFORM_FEE_PERCENTAGE */
  PLATFORM_COMMISSION_PERCENTAGE: SHARER_PLATFORM_FEE_PERCENTAGE,

  PAYMENT_PROCESSING_FEE: 0.029, // 2.9%
  GST_RATE: 0.1, // 10%

  // Points system
  POINTS_TO_DOLLAR_RATE: 0.1, // 100 points = $10 AUD

  // Currency
  DEFAULT_CURRENCY: "AUD",

  // Booking limits
  MIN_BOOKING_DURATION: 1, // days
  MAX_BOOKING_DURATION: 365, // days
  MAX_ADVANCE_BOOKING: 365, // days in advance
} as const;

/**
 * Format price as AUD currency
 */
export function formatPrice(
  amount: number,
  currency: string = PRICING_CONSTANTS.DEFAULT_CURRENCY
): string {
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency,
  }).format(amount);
}
